import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "survey-receive-options--legend-label"
}
const _hoisted_5 = {
  key: 1,
  class: "survey-receive-options--answer"
}

import { onMounted, ref } from 'vue'
import type { Ref } from 'vue'
import {
    LABEL_LEFT_NPS_DEFAULT,
    LABEL_LEFT_FIVESTAR_DEFAULT,
    LABEL_RIGHT_NPS_DEFAULT,
    LABEL_RIGHT_FIVESTAR_DEFAULT,
    ReceiveOption,
    SurveyDisplayValues,
    SurveyParams,
    OptionLabels,
} from '@/entities/conversation'
import { shuffleArray } from '@/utils/array'
import { computed } from 'vue'

interface Props {
    item: ReceiveOption
    surveyDisplayValues?: SurveyDisplayValues
    surveyParams: SurveyParams
    optionLabels: OptionLabels | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationItemReceiveOption',
  props: {
    item: {},
    surveyDisplayValues: {},
    surveyParams: {},
    optionLabels: {}
  },
  emits: ['callNext'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const options = ref()
const hasAnswer = ref(false)
const selectedAnswer = ref('')
const selectedOptionKeys: Ref<string[]> = ref([])

const isMultiSelect = computed(() => props.item.multiSelect)
const isRandomOptions = computed(() => props.item.randomizeOrder)
const isNps = computed(() => {
    if (props.item.param && !!props.item.param.match(/_nps$/)) {
        return true
    }
    if (props.item.cardType && props.item.cardType == 'nps') {
        return true
    }
    return false
})
const isFiveStar = computed(() => {
    if (props.item.param && !!props.item.param.match(/_fivestar$/)) {
        return true
    }
    if (props.item.cardType && props.item.cardType == 'fivestar') {
        return true
    }
    return false
})

onMounted(() => {
    if (isRandomOptions.value) {
        const randomOptions = shuffleArray(props.item.options)
        options.value = randomOptions
    } else {
        options.value = props.item.options
    }

    if (props.surveyDisplayValues?.[props.item?.param]) {
        displaySavedValues(props.surveyDisplayValues[props.item?.param])
    }
})

const displaySavedValues = (selectedOptionsKeys) => {
    const selectedOptionsKeysArray = selectedOptionsKeys.split('|')
    const selectedOptionKeys = props.item.options.filter((option) =>
        selectedOptionsKeysArray.includes(option.key)
    )

    const selectedOptionValues = selectedOptionKeys.map(
        (option) => option.value
    )

    hasAnswer.value = true
    selectedAnswer.value = selectedOptionValues.join(', ')
}

const handleSelectOption = (option, evt: MouseEvent) => {
    evt.preventDefault()
    if (isMultiSelect.value) {
        const selectedKey = option.key as string

        if (selectedOptionKeys.value.includes(selectedKey)) {
            selectedOptionKeys.value = selectedOptionKeys.value.filter(
                (option) => option !== selectedKey
            )
        } else {
            selectedOptionKeys.value.push(selectedKey)
        }
    } else {
        selectedAnswer.value = option.value
        hasAnswer.value = true
        const newValue = { [props.item.param]: option.key }
        emit('callNext', newValue, selectedAnswer.value)
    }
}

const handleDone = (evt: MouseEvent) => {
    evt.preventDefault()
    if (selectedOptionKeys.value.length > 0) {
        const selectedKeys = selectedOptionKeys.value.join('|')
        displaySavedValues(selectedKeys)
        const newValue = { [props.item.param]: selectedKeys }
        emit('callNext', newValue, selectedAnswer.value)
    }
}

const getLabelLeft = () => {
    if (isNps.value) {
        if (props.optionLabels?.labelLeft) {
            return props.optionLabels?.labelLeft
        }

        if (props.item.optionLabels?.labelLeft) {
            return props.item.optionLabels?.labelLeft
        }
        if (props.surveyParams.labelLeft) {
            return props.surveyParams.labelLeft
        }

        return LABEL_LEFT_NPS_DEFAULT
    }

    if (isFiveStar.value) {
        if (props.surveyParams.labelLeft) {
            return props.surveyParams.labelLeft
        }

        return LABEL_LEFT_FIVESTAR_DEFAULT
    }

    return null
}

const getLabelRight = () => {
    if (isNps.value) {
        if (props.optionLabels?.labelRight) {
            return props.optionLabels?.labelRight
        }
        if (props.item.optionLabels?.labelRight) {
            return props.item.optionLabels?.labelRight
        }
        if (props.surveyParams.labelRight) {
            return props.surveyParams.labelRight
        }

        return LABEL_RIGHT_NPS_DEFAULT
    }

    if (isFiveStar.value) {
        if (props.surveyParams.labelRight) {
            return props.surveyParams.labelRight
        }

        return LABEL_RIGHT_FIVESTAR_DEFAULT
    }

    return null
}

return (_ctx: any,_cache: any) => {
  return (!hasAnswer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["survey-receive-options", {
                nps: isNps.value,
                fivestar: isFiveStar.value,
            }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.key,
              class: _normalizeClass(["survey-receive-options--item", { selected: selectedOptionKeys.value.includes(option.key) }]),
              type: "button",
              onClick: ($event: any) => (handleSelectOption(option, $event))
            }, _toDisplayString(option.value), 11, _hoisted_2))
          }), 128)),
          (isMultiSelect.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["survey-receive-options--done", { disabled: selectedOptionKeys.value.length === 0 }]),
                disabled: selectedOptionKeys.value.length === 0,
                type: "button",
                onClick: handleDone
              }, " Done ", 10, _hoisted_3))
            : _createCommentVNode("", true)
        ], 2),
        (isNps.value || isFiveStar.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(getLabelLeft()), 1),
              _createElementVNode("div", null, _toDisplayString(getLabelRight()), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(selectedAnswer.value), 1)
      ]))
}
}

})